// extracted by mini-css-extract-plugin
export default {"company":"KOC1bWyGbBiHebUYeX_e","logo":"MQ_ztZ5J5WyZSkUFN8Bl","cover":"iGHdZTBYWC2qEFnISbaK","icon":"hybHkmRsj8AUI0OFRxaL","highlights":"gaZooMXE8Ap97NhLz4Yw"};